import { loginFormHandler } from './login';

// executes as soon as loaded, primarily for templates
loginFormHandler.setupLoginPage();
